import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Divider } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const MoreActionTooltip = (props) => {
   const { t } = useTranslation();
   const navigate = useNavigate();
   const { holidayDescription, userLeaves, leavesNumber, date } = props;
   const CustomMoreActionTooltip = withStyles({
      tooltip: {
         '&.MuiTooltip-tooltip': {
            padding: 0,
            borderRadius: '6px',
            fontFamily: "'Montserrat', san-serif",
         },
      },
   })(Tooltip);

   const handleClick = () => {
      navigate('/leave-and-holiday-management', {
         state: {
            myData: date,
         },
      });
   };

   return (
      <div className='w-full overflow-hidden'>
         <CustomMoreActionTooltip
            title={
               <div className='bg-[#FFFFFF] grid grid-cols-1 gap-x-3 gap-y-4 text-xs px-3'>
                  <div className='flex flex-col gap-1 text-[#1F2937]'>
                     <div className='pt-2 text-[#1F2937]'>
                        <span className='font-medium'>{t('common.holidays')}:</span>{' '}
                        <span>{holidayDescription || t('common.no-holidays')}</span>
                     </div>

                     <div className='pt-2 text-[#1F2937]'>
                        <span className='font-medium'>{t('common.leaves')}:</span>{' '}
                        <span>{leavesNumber || t('common.no-leaves')}</span>
                     </div>
                  </div>

                  <div
                     className='col-span-2 border-t border-solid border-[#E5E7EB] cursor-pointer'
                     onClick={() =>
                        navigate('/controlpanel/leave-and-holiday-management', {
                           state: { myData: date },
                        })
                     }
                  >
                     <p className='py-2 text-[#0057FF]'>
                        {t('common.click-for-more-action')}
                     </p>
                  </div>
               </div>
            }
            placement='top'
            arrow
         >
            <div>{props.children}</div>
         </CustomMoreActionTooltip>
      </div>
   );
};

export default MoreActionTooltip;
